/**
 * Breakpoint pixel values and media query strings for use in JavaScript/TypeScript.
 * Keep in sync with src/styles/_breakpoints.scss (and css-generator.php where applicable).
 */
export const MOBILE_MAX_PX = 767
export const TABLET_MIN_PX = 768
export const TABLET_MAX_PX = 1024
export const DESKTOP_MIN_PX = 1025

/** Media query: viewport width up to mobile max (max-width: 767px). */
export const MEDIA_MOBILE_MAX = `(max-width: ${MOBILE_MAX_PX}px)`

/** Media query: viewport width from tablet min and up (min-width: 768px). */
export const MEDIA_TABLET_MIN = `(min-width: ${TABLET_MIN_PX}px)`

/** Media query: tablet range only (768px–1024px). */
export const MEDIA_TABLET = `(min-width: ${TABLET_MIN_PX}px) and (max-width: ${TABLET_MAX_PX}px)`

/** Media query: viewport width from desktop min and up (min-width: 1025px). */
export const MEDIA_DESKTOP_MIN = `(min-width: ${DESKTOP_MIN_PX}px)`
